import { render } from "./MagicBox.vue?vue&type=template&id=764aca8e"
import script from "./MagicBox.vue?vue&type=script&lang=js"
export * from "./MagicBox.vue?vue&type=script&lang=js"
script.render = render

export default script